'use client';

import { useEffect } from 'react';

interface Props {
    hasMedia: boolean;
    mediaAspectRatio: string | undefined;
    blockType: string;
}

export function MediaAspectRatioWarning({ blockType, hasMedia, mediaAspectRatio }: Props) {
    useEffect(() => {
        if (hasMedia && !mediaAspectRatio && process.env.NODE_ENV === 'development') {
            console.error(
                `${blockType} has video or image attached, but 'mediaAspectRatio' was not set. Please set the aspect ratio in Contentful to prevent CLS issues.`,
            );
        }
    }, [blockType, hasMedia, mediaAspectRatio]);

    return null;
}
